angular.module("app").controller("GameReleaseEditPageController", [
    '$scope',
    'errorHandler',
    'logger',
    '$uibModalInstance',
    'gameName',
    'gameId',
    'casinoJobService',
    'casinoGameService',
    'casinoSkinGameJobs',
    'groups',
    function ($scope, errorHandler, logger, $modalInstance, gameName, gameId, casinoJobService, casinoGameService, casinoSkinGameJobs, groups) {
        var attached = [];
        var detached = [];

        $scope.customPosition = null;
        $scope.releaseMethod = 1;
        $scope.gameName = gameName;
        $scope.hasCustomPosition = false;
        $scope.selectedGroups = [];

        $scope.skinGameJobs = angular.copy(casinoSkinGameJobs).filter((item) => item.status === '3');
        $scope.skinsList = angular.copy(casinoSkinGameJobs).filter((item) => item.status === '2');
        $scope.groupsList = angular.copy(groups);

        $scope.skinGameJobs.map(function (item) {
            item.checked = false;
        });
        $scope.skinsList.map(function (item) {
            item.checked = false;
        });

        $scope.addedItemsCount = $scope.skinGameJobs.length;
        $scope.addingItemsCount = $scope.skinsList.length;
        $scope.isCheckedPossibleCancellation = false;
        $scope.allQuery = "";
        $scope.existingQuery = "";
        $scope.state = {
            selectAllForAddModel: false,
            selectAllForRemoveModel: false
        };

        $scope.save = function () {
            if (attached.length === 0 && detached.length === 0) {
                logger.logError("global.no_changes");
                return;
            }
            var requestData = {switchSkinsForGame: {game_id: gameId, attached: attached, detached: detached}};

            casinoGameService.switchSkins(requestData).then(
                function (response) {
                    if (response.status === 'ok') {
                        logger.logSuccess("updated");
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.addSelected = function () {
            var count = 0;
            var itemsToRemove = [];

            $scope.skinsList.forEach(function (item, i) {
                if (item.checked) {
                    item.checked = false;
                    $scope.skinGameJobs.push({
                        name: item.name,
                        id: item.id,
                        skin_id: item.skin_id,
                        checked: false
                    });

                    itemsToRemove.push(i);

                    var detachedIndex = detached.indexOf(item.skin_id);
                    if (detachedIndex === -1) {
                        attached.push(item.skin_id);
                    } else {
                        detached.splice(detachedIndex, 1);
                    }
                    ++count;
                }
            });

            itemsToRemove.reverse().forEach(function(i) {
                $scope.skinsList.splice(i, 1);
            });

            $scope.addingItemsCount -= count;
            $scope.addedItemsCount += count;
            $scope.state.selectAllForAddModel = false;
            $scope.$applyAsync();
        };
        $scope.removeSelected = function () {
            var count = 0;
            var itemsToRemove = [];

            $scope.skinGameJobs.forEach(function (skin, i) {
                if (skin.checked) {
                    skin.checked = false;
                    $scope.skinsList.push({
                        name: skin.name,
                        id: skin.id,
                        skin_id: skin.skin_id,
                        checked: false
                    });

                    itemsToRemove.push(i);

                    var attachedIndex = attached.indexOf(skin.skin_id);
                    if (attachedIndex === -1) {
                        detached.push(skin.skin_id);
                    } else {
                        attached.splice(attachedIndex, 1);
                    }

                    ++count;
                }
            });

            itemsToRemove.reverse().forEach(function(i) {
                $scope.skinGameJobs.splice(i, 1);
            });

            $scope.addingItemsCount += count;
            $scope.addedItemsCount -= count;
            $scope.state.selectAllForRemoveModel = false;
        };
        $scope.filterForAdd = function (skin) {
            var item = getItemFromList($scope.allQuery, [skin]);
            return (item || item === null) && (!function () {
                for (var i = 0, length = $scope.skinGameJobs.length; i < length; i++) {
                    if ($scope.skinGameJobs[i].id === skin.id) {
                        return true
                    }
                }
                return false
            }())
        };
        $scope.filterForRemove = function (skin) {
            var item = getItemFromList($scope.allQuery, [skin]);
            return (item || item === null)
        };
        $scope.getSelectedForAddCount = function () {
            return $scope.skinsList.reduce(function (prev, current) {
                return prev + (current.checked ? 1 : 0);
            }, 0)
        };
        $scope.getSelectedForDeleteCount = function () {
            return $scope.skinGameJobs.reduce(function (prev, current) {
                return prev + (current.checked ? 1 : 0);
            }, 0)
        };

        /**
         * Select all for add
         */
        $scope.selectAllForAdd = function () {
            $scope.skinsList.forEach(function (item) {
                if ($scope.filterForAdd(item)) {
                    item.checked = $scope.state.selectAllForAddModel;
                }
            });
        }

        /**
         * Select all for remove
         */
        $scope.selectAllForRemove = function () {
            $scope.skinGameJobs.forEach(function (item) {
                if ($scope.filterForRemove(item)) {
                    item.checked = $scope.state.selectAllForRemoveModel;
                }
            });
        }
        /**
         * Recalculate counts of sections
         */
        $scope.recalculateCounts = function () {
            var count1 = 0;
            var count2 = 0;
            $scope.skinGameJobs.forEach(function (item) {
                if ($scope.filterForRemove(item)) {
                    ++count1;
                }
            });
            $scope.addedItemsCount = count1;
            $scope.skinsList.forEach(function (item) {
                if ($scope.filterForAdd(item)) {
                    ++count2;
                }
            });
            $scope.addingItemsCount = count2;
        };
        // $scope.validateCustomPosition
        $scope.validateCustomPosition = function () {
            if ($scope.customPosition === undefined || ($scope.customPosition && $scope.customPosition < 3)) {
                $scope.switch_skins_form.useCustomPosition.$touched = true;
                $scope.switch_skins_form.useCustomPosition.$error.required = false;
            } else {
                $scope.switch_skins_form.useCustomPosition.$touched = false;
                $scope.switch_skins_form.useCustomPosition.$error.required = true;
            }
        };

        $scope.getCheckedItemsLength = function (items) {
            return items.filter(item => item.checked).length;
        };

        function getItemFromList(filterQuery, list) {
            if (!!filterQuery) {
                for (var i = 0, length = list.length, regex = new RegExp("^" + filterQuery); i < length; i++) {
                    if (list[i].name.toLowerCase().indexOf(filterQuery.toLowerCase()) !== -1 || regex.test(list[i].id)) {
                        return true
                    }
                }
            } else {
                return null
            }
            return false
        }

        $scope.$watch('selectedGroups', function () {
            $scope.skinGameJobs.forEach(function (skin) {
                if (!skin.groups || !skin.groups.length) return;

                if (!$scope.selectedGroups || !$scope.selectedGroups.length){
                    skin.checked = false;
                    return;
                }

                let skinGroupsArray = skin.groups.split(",");

                skin.checked = $scope.selectedGroups.some(function (group) {
                    return skinGroupsArray.includes(group);
                });

                // $scope.selectedGroups.forEach(function (group) {
                //     skin.checked = skinGroupsArray.includes(group);
                // })
            });
        });
    }
]);